import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en/translations.json';
import roTranslations from './locales/ro/translations.json';

import { EnglishFlag } from '@/assets/english-flag.tsx';
import { RomanianFlag } from '@/assets/romanian-flag.tsx';

// Any used intentionally
/* eslint-disable @typescript-eslint/no-explicit-any */
export type TI18Language = {
  code: 'en' | 'ro';
  Icon?: (arg: any) => React.ReactElement;
};
/* eslint-enable @typescript-eslint/no-explicit-any */

export const AvailableI18Languages: TI18Language[] = [
  {
    code: 'en',
    Icon: EnglishFlag,
  },
  {
    code: 'ro',
    Icon: RomanianFlag,
  },
];

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation';
    resources: {
      translation: typeof enTranslations;
    };
  }
}

export const resources = {
  en: {
    translation: enTranslations,
  },
  ro: {
    translation: roTranslations,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'ro'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
